import { StyleSheet } from 'react-native';
import { tokens } from '@airtel/air-design-system';
export var getSectionHeaderStyles = () => {
  var _tokens$spacing = tokens.spacing,
    SPACING_16 = _tokens$spacing.SPACING_16,
    SPACING_12 = _tokens$spacing.SPACING_12;
  return StyleSheet.create({
    container: {
      flexDirection: 'row',
      width: '100%',
      alignItems: 'center',
      marginBottom: SPACING_16
    },
    avatarStyle: {
      height: '100%',
      width: '100%'
    },
    sectionHeaderTitle: {
      width: '80%',
      paddingLeft: SPACING_12
    },
    avatarContainer: {
      height: 56,
      width: 56
    }
  });
};